import * as gfunctions from '../../../js/generalFunctions';

CCL.FlyToFun = {
  autoload: [
    ['dropdownSelect', $('.select-booking-dropdown').length > 0],
    ['searchFlightsBtn', $('#searchFlightsBtn').length > 0]
  ],

  dropdownSelect() {
    $('#redirectLink').remove();
    $('body').on('click', '.select-booking-dropdown .dropdown-menu .dropdown-item', (e) => {
      $('#searchFlightsBtn').attr('data-flight-booking-id', e.target.innerText.replace(/^#/, ''));
      $('.select-booking-dropdown #select-booking span').html(e.target.innerText);
      $('.search-flight-error').css('display', 'none');
      $('.select-booking-dropdown .dropdown-toggle').addClass('ada-element-focus');
      const selectBooking = e.currentTarget.innerText;
      $('.select-booking-dropdown .dropdown-toggle span').attr('aria-label', `Select booking: ${selectBooking} selected`);
      $('.select-booking-dropdown .dropdown-toggle span').attr('role', 'alert');
      $('.select-booking-dropdown .dropdown-toggle span').attr('aria-live', 'assertive');
      setTimeout(() => {
        $('.select-booking-dropdown .dropdown-toggle').focus();
      }, 100);
    });
  },
  searchFlightsBtn() {
    $('body').on('click', '#searchFlightsBtn', (e) => {
      const flightBookingId = $('#searchFlightsBtn').attr('data-flight-booking-id');
      gfunctions.showLoader();
      $('#redirectLink').remove();
      $.ajax({
        type: 'GET',
        url: `/shop/searchFlights?bookingid=${flightBookingId}`,
        contentType: 'application/json'
      }).done((res) => {
        gfunctions.hideLoader();
        if (res.Status === true) {
          if (window.matchMedia('(max-width: 767px)').matches) {
            $('#searchFlightsBtn').after(`<button 
            onclick=window.open('${res.redirectURL}','_self')
            id="redirectLink" style="display:none">test</button>`);
            $('#redirectLink').trigger('click');
          } else {
            $('#searchFlightsBtn').after(`<button 
        onclick=window.open('${res.redirectURL}')
        id="redirectLink" style="display:none">test</button>`);
            $('#redirectLink').trigger('click');
          }
        } else {
          console.log('Sorry No flight available for selected booking.');
          if (res.response) {
            $('.search-flight-error').html(res.response[0].errorDescription).css('display', 'block');
          } else if (res.displayErrorMessage) {
            $('.search-flight-error').html(res.displayErrorMessage).css('display', 'block');
          }
        }
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('Something went wrong in Search Flights AJAX');
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-fly-to-fun/pdp-fly-to-fun.js